(() => {
  const init = (section) => {
    if (!section || section.dataset.ecBlogReady === 'true') return;

    const viewport = section.querySelector('[data-ec-blog-viewport]');
    const cards = [...section.querySelectorAll('[data-ec-blog-card]')];
    const current = section.querySelector('[data-ec-blog-current]');
    const total = section.querySelector('[data-ec-blog-total]');
    const previous = section.querySelector('[data-ec-blog-prev]');
    const next = section.querySelector('[data-ec-blog-next]');
    if (!viewport || !cards.length) return;

    section.dataset.ecBlogReady = 'true';
    if (total) total.textContent = cards.length;

    const activeIndex = () => {
      const viewportLeft = viewport.getBoundingClientRect().left;
      let nearest = 0;
      let distance = Infinity;
      cards.forEach((card, index) => {
        const nextDistance = Math.abs(card.getBoundingClientRect().left - viewportLeft - 20);
        if (nextDistance < distance) {
          nearest = index;
          distance = nextDistance;
        }
      });
      return nearest;
    };

    const update = () => {
      const index = activeIndex();
      if (current) current.textContent = index + 1;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === cards.length - 1;
    };

    const goTo = (index) => {
      const target = cards[Math.max(0, Math.min(cards.length - 1, index))];
      if (!target) return;
      viewport.scrollTo({
        left: target.offsetLeft - 20,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    previous?.addEventListener('click', () => goTo(activeIndex() - 1));
    next?.addEventListener('click', () => goTo(activeIndex() + 1));

    let frame;
    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-ec-blog]')) init(root);
    root.querySelectorAll('[data-ec-blog]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
